import { render, staticRenderFns } from "./PageRegisterSupport.vue?vue&type=template&id=759382e6&scoped=true&"
import script from "./PageRegisterSupport.vue?vue&type=script&lang=js&"
export * from "./PageRegisterSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759382e6",
  null
  
)

export default component.exports